/** @jsxImportSource @emotion/react */
import {
  FormControlLabel,
  FormControlLabelProps,
  styled,
  Switch as MuiSwitch,
  SxProps,
  Theme,
} from '@mui/material';
import React, { FC } from 'react';
import { useField } from 'formik';
import { inheritDataTestId, INHERITED_DATA_TEST_ID } from '@/utils/testId.ts';

export const Switch = styled(MuiSwitch)`
  padding: 15px 12px;
  width: 65px;
  .MuiSwitch {
    &-thumb {
      width: 22px;
      height: 22px;
    }
    &-switchBase {
      padding: 8px;
    }
  }
  .Mui-checked {
    transform: translateX(26px) !important;
  }
`;

Switch.defaultProps = {
  color: 'secondary',
};

type SwitchControlProps = Omit<FormControlLabelProps, 'control'>;
export const SwitchControl: FC<SwitchControlProps> = ({ ...restProps }) => {
  return (
    <FormControlLabel
      data-test-id={INHERITED_DATA_TEST_ID}
      sx={{ ml: 0, gap: 12, 'MuiTypography-root': { fontSize: '14px' } }}
      control={<Switch data-test-id={inheritDataTestId(restProps, 'switch')} />}
      labelPlacement={'start'}
      {...restProps}
    />
  );
};

export const SwitchControlF: FC<{
  label: string;
  name: string;
  className?: string;
  sx?: SxProps<Theme>;
}> = (props) => {
  const { label: _, ...restProps } = props;
  const [field] = useField({ type: 'checkbox', ...restProps });
  return (
    <SwitchControl
      data-test-id={INHERITED_DATA_TEST_ID}
      {...field}
      {...props}
    />
  );
};
